document.addEventListener("DOMContentLoaded", function () {
    var e = document.querySelector(".isotope");
    if (null !== e) {
        var t = new Masonry(e, { columnWidth: ".grid-sizer", itemSelector: ".item", isAnimated: !0, gutter: ".gutter-sizer", layoutMode: "fitRows", percentPosition: !0 });
        imagesLoaded(e).on("progress", function () {
            t.layout();
        });
    }
})
